export const artistPageTabs = {
  discography: 1,
  similar: 2,
  about: 3,
  tracks: 4,
  albums: 5,
  followers: 6,
  live: 7,
  agenda: 8,
} as const;
